import CryptoJS from 'crypto-js';
import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';
import isToday from 'dayjs/plugin/isToday';
import isTomorrow from 'dayjs/plugin/isTomorrow';
import images from '../assets/images';
import { materialsData } from './interface';
import moment from 'moment-timezone';
import { VideosListForCategory } from '../pages/SyndicatedVideos/SyndicatedVideos';
import { AnnouncementObjectType } from '../pages/AdminAnnouncement/AdminAnnouncement';
import { Participant } from '../MeetContext/MeetContext';
import { v4 as uuidv4 } from "uuid";
import { trackButtonClick } from '../firebase/analyticsHelper';
import { ButtonClickEvents } from '../firebase/constants/events';
import { JITSI, MYLIBRARY_TEXTS } from './constants';

const { ResetCode,PencilIcon, DeleteClass, MenuShareIcon, pdfImg, epub, csvImg, powerpoint, excelPreview, podcast, docsImg } = images;

// To modify each word first letter in uppercase
export function capitalizeFirstLetterOfEachWord(sentence:string) {
    return sentence && sentence.replace(/\b\w/g, char => char.toUpperCase());
  }

  const passwordHashKey = process.env.REACT_APP_ENCRYPT_SECRET_KEY;
  
 export function getDecryptedDataWithSecretKey(encryptedText: any): { originalText: string } {
    try {
        if (!passwordHashKey || typeof encryptedText !== 'string') {
            throw new Error("Missing key or invalid input");
        }

        const bytes = CryptoJS.AES.decrypt(encryptedText, passwordHashKey);
        const originalText = bytes.toString(CryptoJS.enc.Utf8);

        return {
            originalText: originalText || "-"  
        };
    } catch (e:any) {
        console.error("Decryption error:", e.message);
        return {
            originalText: "-" 
        };
    }
}

export function getEncryptedDataWithSecretKey(text: any){
  const key = passwordHashKey ? passwordHashKey : '';
  const finalText = CryptoJS.AES.encrypt(text, key).toString();
  return finalText;
}

//To format the file size
export const formatFileSize = (sizeInBytes: number): string => {
  if (sizeInBytes >= 1024 * 1024) {
      // Convert to megabytes (MB) with two decimal places
      return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} Mb`;
  } else {
      // Convert to kilobytes (KB) with two decimal places
      return `${(sizeInBytes / 1024).toFixed(2)} Kb`;
  }
};




dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(isToday);
dayjs.extend(isTomorrow);
export const getFormattedDateInfo = (startDate: string) => {
  // Set the timezone to the local timezone
  dayjs.tz.setDefault(dayjs.tz.guess());

  // Parse the startDate in the local timezone
  const today = dayjs().startOf('day');
  const tomorrow = today.add(1, 'day').startOf('day');
  const start = dayjs(startDate).startOf('day');

  // Calculate total days difference
  const daysDiff = start.diff(tomorrow, 'day');

  let dayMessage;
  if (start.isSame(today, 'day')) {
    dayMessage = 'Today';
  } else if (start.isSame(tomorrow, 'day')) {
    dayMessage = 'Tomorrow';
  } else if (daysDiff >= 0) {
    dayMessage = `${daysDiff} ${daysDiff === 1 ? 'day' : 'days'} left`; // Add 1 to include tomorrow
  } else {
    dayMessage = 'Date has passed';
  }

  const formattedDate = start.format('DD MMMM');
  const dayOfWeek = start.format('dddd');

  return { dayMessage, formattedDate, dayOfWeek };
};

export const getMenuItems = (handleCloseActions: () => void, handleMaterialActions: (data: any, action: string) => void, setOpenConfirmationPopup: any, setAction: any, selectedMaterial: materialsData | null | VideosListForCategory|AnnouncementObjectType|undefined, menuType?: string) => [
  ...(((menuType === "syndicatedVideos") || (menuType === MYLIBRARY_TEXTS?.IMAGES_TEXT) || (menuType === "Ebooks/My Learning Materials") || (menuType === "QuestionBank") || (menuType === "examinationGuides"))
    ? [
        {
          icon: PencilIcon,
          label: 'Edit',
          onClick: () => {
            console.log("edit clicked", selectedMaterial);
            handleCloseActions();
            if (selectedMaterial) {
                handleMaterialActions(selectedMaterial, "edit")
            }
          },
        },
      ]
    : []),
  {
      icon: ResetCode,
      label: 'Undo shared',
      onClick: () => {
          console.log("undo share clicked", selectedMaterial);
          handleCloseActions();
          if (selectedMaterial) {
              handleMaterialActions(selectedMaterial, "undoShare")
          }
      },
  },
  {
      icon: DeleteClass,
      label: 'Delete for All',
      onClick: () => {
          setAction('delete');
          setOpenConfirmationPopup(true);
          handleCloseActions();
      },
  },
];


export const formatSavedDate = (dateString: string | undefined) => {
  const date = moment(dateString);
  const today = moment().startOf('day');
  const yesterday = moment().subtract(1, 'days').startOf('day');

  if (date.isSame(today, 'day')) {
    return 'Today';
  } else if (date.isSame(yesterday, 'day')) {
    return 'Yesterday';
  } else {
    return date.format('Do MMMM YYYY');
  }
};


export const getMenuItemsForEditShare = (handleCloseActions: () => void, handleMaterialActions: (data: any, action: string) => void, setOpenConfirmationPopup: any, setAction: any, selectedMaterial: any, undoShareAnnouncement: () => void) => [
  {
      icon: PencilIcon,
      label: 'Edit',
      onClick: () => {
          handleCloseActions();
          if (selectedMaterial) {
              handleMaterialActions(selectedMaterial, "edit")
          }
      },
  },
  {
      icon: DeleteClass,
      label: 'Delete',
      onClick: () => {
          trackButtonClick(ButtonClickEvents?.ANNOUNCEMENT_DELETE_BUTTON_CLICK, {
              description: "User clicks the delete button on announcement card"
          });
          setAction('delete');
          setOpenConfirmationPopup(true);
          handleCloseActions();
      },
  },
  {
    icon: selectedMaterial?.isShare ? ResetCode : MenuShareIcon,
    label: selectedMaterial?.isShare ? 'Undo Share' : 'Share to All',
    onClick: () => {
        setAction(selectedMaterial?.isShare ? 'undoShare' : 'shareAll');
        if(selectedMaterial?.isShare){
          trackButtonClick(ButtonClickEvents?.ANNOUNCEMENT_UNDO_SHARE_BUTTON_CLICK, {
            description: "User clicks the undo share button on announcement card"
          });
          undoShareAnnouncement();
        }else {
          trackButtonClick(ButtonClickEvents?.ANNOUNCEMENT_SHARE_TO_ALL_BUTTON_CLICK, {
            description: "User clicks the share to all button on announcement card"
          });
          setOpenConfirmationPopup(true);
        }
        handleCloseActions();
    },
},
];


const timezone = moment?.tz?.guess();
//To get time difference between start and end date
export const getTimeDifference = (start: string, end: string) => {
    const startMoment = moment.tz(start, timezone);
    const endMoment = moment.tz(end, timezone);
    const duration = moment.duration(endMoment.diff(startMoment));
    const hours = duration.hours();
    const minutes = duration.minutes();
    return { hours, minutes, duration };
};

export const calculateDays = (date: string, year?: boolean) => {
  // Parse the input date and convert it to the local timezone
  const startDate = moment.tz(date, moment.tz.guess());

  // Get today and tomorrow in the local timezone
  const today = moment().startOf('day');
  const tomorrow = moment().add(1, 'day').startOf('day');

  // Check if the startDate is today, tomorrow, or another day
  if (startDate.isSame(today, 'day')) {
      return 'Today';
  } else if (startDate.isSame(tomorrow, 'day')) {
      return 'Tomorrow';
  } else {
      return year ? startDate.format('dddd, D MMMM YYYY') : startDate.format('dddd, D MMMM');
  }
};

//to format the input time
export const formatTime = (date: string) => {
    return moment.tz(date, timezone).format('h:mm A').toLowerCase();
};

//To get the duration between start and end date
export const calculateDuration = (start: string, end: string) => {
    const { hours, minutes } = getTimeDifference(start, end);
    if (hours > 0) {
        return `${hours} hour${hours > 1 ? 's' : ''} ${minutes > 0 ? `${minutes} minute${minutes > 1 ? 's' : ''}` : ''}`;
    }
    return `${minutes} minute${minutes > 1 ? 's' : ''}`;
};

//To split the duration
export const splitDuration = (start: string, end: string) => {
  const { duration } = getTimeDifference(start, end);
  const totalMinutes = duration.asMinutes();
  let part1Minutes;
  let part2Minutes;

  if(totalMinutes === 15){
    part1Minutes = 10;
    part2Minutes = 5;
  } else if(totalMinutes === 30){
    part1Minutes = 20;
    part2Minutes = 10;
  }else{
    part1Minutes = Math.floor(totalMinutes * 0.75);
    part2Minutes = Math.ceil(totalMinutes * 0.25);
  }

  //To get the particular minutes format
  const formatPart = (minutes: number) => {
      if (minutes >= 60) {
          const hours = Math.floor(minutes / 60); 
          const remainingMinutes = minutes % 60;
          return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes > 0 ? `${remainingMinutes} min${remainingMinutes > 1 ? 's' : ''}` : ''}`;
      }
      return `${minutes} min${minutes > 1 ? 's' : ''}`;
  };

  return { part1: formatPart(part1Minutes), part2: formatPart(part2Minutes) };
};

//Check any live session is now
export const checkIsTimeNow = (start: string, end: string) => {
const now = moment()?.tz(timezone);
const startMoment = moment.tz(start, timezone);
const endMoment = moment.tz(end, timezone);

return now?.isSameOrAfter(startMoment) && now?.isSameOrBefore(endMoment);
};

//To format classroom total count
export const formatClassroomStudentsCount = (count: number) => {
  if (count === 0) {
    return "No Student";
  } else if (count === 1) {
    return "1 Student";
  } else {
    return `${count} Students`;
  }
};

//To format classroom puplis total count
export const formatPupilsCount = (count: number) => {
  if (count === 0) {
    return "No Pupil";
  } else if (count === 1) {
    return "1 Pupil";
  } else {
    return `${count} Pupils`;
  }
};

//To format classroom puplis total count
export const formatStudentPupilsCount = (count: number,availableStudents:number) => {
  if (count === 0 || availableStudents === 0) {
    return "No Pupil";
  } else if (availableStudents === 1) {
    return `1 / ${count} Pupil`;
  } else {
    return `${availableStudents} / ${count} Pupils`;
  }
};



//To get the particular minutes format
export const formatPart = (minutes: number) => {
  if (minutes >= 60) {
      const hours = Math.floor(minutes / 60); 
      const remainingMinutes = minutes % 60;
      return `${hours} hour${hours > 1 ? 's' : ''} ${remainingMinutes > 0 ? `${remainingMinutes} min${remainingMinutes > 1 ? 's' : ''}` : ''}`;
  }
  return `${minutes} min${minutes > 1 ? 's' : ''}`;
};


// Helper function to convert "HH:mm" to total minutes
export const convertToMinutes = (period: string) => {
  const [hours, minutes] = period?.split(':').map(Number);
  return hours * 60 + minutes;
};

//To format the duration of videos
export const formatDuration = (duration: number) => {
  const hours = Math.floor(duration / 3600);
  const minutes = Math.floor((duration % 3600) / 60);
  const seconds = Math.floor(duration % 60);

  if (hours > 0) {
      return `${hours}:${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  } else {
      return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  }
};

    //To format classroom total count
  export const formatVideosCount = (count: number) => {
    if (count === 0) {
        return "No video archive";
    } else if (count === 1) {
        return "1 video archive";
    } else {
        return `${count} videos archive`;
    }
  };

  export const handleInputWithoutSpaces = (e: React.FormEvent<HTMLInputElement>) => {
    e.currentTarget.value = e.currentTarget.value.replace(/\s+/g, '');
  };

  export const handlePhoneNumberInput = (e: React.FormEvent<HTMLInputElement>) => {
    const input = e.currentTarget;
    input.value = input.value.replace(/\D/g, '');
    // if (input.value.length > 10) {
    //   input.value = input.value.slice(0, 10);
    // }
  };


  export const getSendTime = (date: string) => {
    const startMoment = moment.tz(date, timezone);
    const endMoment = moment.tz(moment().toISOString(), timezone);
    
    // Use diff() to get total differences instead of duration component values
    const totalMinutes = endMoment.diff(startMoment, 'minutes');
    const totalHours = endMoment.diff(startMoment, 'hours');
    
    let time;
    // Show relative time only if message is less than 1 hour old
    if(totalHours < 1 && totalMinutes >= 0){
       time = `${totalMinutes} min`
       if(totalMinutes < 1){
          time = 'Now'
       }
    }else{
        time = moment(date).format('h:mm A');
      }

    return time;
  }


  export const DaysAgoCalculator = (date: string,previousDate?: string ) => {
    // Get the current date (use start of day for accurate day comparison)
    const today = previousDate ? moment(previousDate).startOf('day') : moment().startOf('day');
    
    // Parse the given date (use start of day for accurate day comparison)
    const pastDate = moment(date).startOf('day');
    
    // Calculate the actual difference in days and months using diff()
    const differenceDate = today.diff(pastDate, 'days');
    const differenceMonth = today.diff(pastDate, 'months');
    return {differenceDate, differenceMonth};

  }

  export const getDividerTime = (date:string,previousDate: string)=>{
    // const sendTimestamp = getTimeDifference(date,previousDate);
    let time;
    const daysFromToday = DaysAgoCalculator(date)?.differenceDate;
    const monthsFromToday = Math.abs(DaysAgoCalculator(date)?.differenceMonth);
    
    if(previousDate !== ''){
    // Check if there's at least 1 day difference between previous message and current message
    if(DaysAgoCalculator(previousDate, date)?.differenceDate >= 1){
      if(daysFromToday === 0){
        time = 'Today'
      }else if(daysFromToday === 1){
        time = 'Yesterday'
      }else if(monthsFromToday >= 12){
        time = moment(date).format('dddd, MMM D, YYYY')
      }else {
        time = moment(date).format('dddd, MMM D')
      }
    }
  }else {
    // First message (no previous message)
    if(daysFromToday === 0){
      time = 'Today'
    }else if(daysFromToday === 1){
      time = 'Yesterday'
    }else if(monthsFromToday >= 12){
      time = moment(date).format('dddd, MMM D, YYYY')
    }else {
      time = moment(date).format('dddd, MMM D')
    }
  }
    return time

  }

// Helper function to check if all users have updatedAt
const allUsersHaveUpdatedAt = (users: Participant[]): boolean =>
  users.every((user) => user.updatedAt);

// Reusable sorting function
export const sortParticipants = (participantsObj: Record<string, Participant>): Participant[] => {
  const participants = Object.values(participantsObj);

  // Separate users into two categories
  const usersWithAudioOrHand = participants.filter(
    (user) => user.preference?.audio || user.preference?.hand
  );
  const otherUsers = participants.filter(
    (user) => !user.preference?.audio && !user.preference.hand
  );

  // If all users in usersWithAudioOrHand have the updatedAt field, sort by updatedAt
  if (allUsersHaveUpdatedAt(usersWithAudioOrHand)) {
    usersWithAudioOrHand.sort((a, b) => {
      if (a.updatedAt && b.updatedAt) {
        return b.updatedAt - a.updatedAt; // Latest first
      }
      return 0; // Fallback in case of missing updatedAt, though this shouldn't happen since we're checking
    });
  } else {
    // If not all have updatedAt, sort by userName
    usersWithAudioOrHand.sort((a, b) => a.userName?.localeCompare(b.userName));
  }

  // Sort the other users by userName
  otherUsers.sort((a, b) => a.userName?.localeCompare(b.userName));

  // Combine the sorted arrays
  return [...usersWithAudioOrHand, ...otherUsers];
};

 // Calculate if the message is within the last hour
 export const isMessageWithinLastHour = (data:string) => {
  const messageCreatedAt = moment(Number(data));
  const currentTime = moment();
  const timeDifference = currentTime.diff(messageCreatedAt, 'seconds');
  return timeDifference <= 3600; // 3600 seconds = 1 hour
};

export const saveFileMetadata = (fileName: string | undefined, metadata: { subCategory: string | undefined, subject: string | undefined}) => {
  const metadataKey = `fileMetadata_${fileName}`;
  localStorage.setItem(metadataKey, JSON.stringify(metadata));
};

export const getAppVersion = async (): Promise<string | null> => {
  return new Promise((resolve, reject) => {
    const onDeviceReady = async () => {
      if (window.cordova) {
        try {
          const version = await window?.cordova?.getAppVersion?.getVersionNumber();
          resolve(version);
        } catch (error) {
          console.error("Error getting app version:", error);
          reject(error);
        }
      } else {
        reject("Cordova not available");
      }
    };

    document.addEventListener("deviceready", onDeviceReady, { once: true });
  });
};

export const getDeviceUUID = (): Promise<string> => {
  return new Promise((resolve, reject) => {
    document.addEventListener('deviceready', () => {
      if (window?.device && window?.device.uuid) {
        resolve(window?.device?.uuid);
      } else {
        reject('Device UUID not available');
      }
    }, false);
  });
};


export const formatDisplayValue = (value: string | undefined | null) => {
  return value ? value : '-';
};

export const formatLessonPeriodTime = (timeString: string) => {
  const localTime = moment(timeString, 'HH:mm:ssZ').local();
  return localTime.format('h:mmA');
};

export const capitalizeWords = (text:string|undefined) => {
  return text?.replace(/\b\w/g, (char) => char.toUpperCase());
};

 // Get user avatar based on role
 export const getUserAvatarUrl = (user:any) => {
  return user?.uRole === 'TEACHER'
    ? user?.teachersByUId?.nodes?.[0]?.tAvatarUrl
    : user?.uRole === 'STUDENT'
    ? user?.studentsByUId?.nodes?.[0]?.sAvatarUrl
    : user?.schoolAdminsByUId?.nodes?.[0]?.saAvatarUrl;
};

export const getScreenDimensions = () => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  const isMobileScreen = width <= 768;  
  return { width, height, isMobileScreen };
};

export const generateUniqueMeetingId = () => {
  // Generate a unique meeting ID
  const meetingId = uuidv4();
  return meetingId;
};

export const getFileViewerType = (fileType: string) => {
  if(fileType === "xls" || fileType === "xlsx"){
    return "excel";
  }
  else if (fileType === "doc" || fileType === "docx") {
    return "doc";
  }
  else {
      return "ppt";
  }
};   


export const formatPhoneNumber = (phoneNumber: string): string => {
  return phoneNumber.startsWith("+") ? phoneNumber : `+233${phoneNumber}`;
};

type JwtValidationResult = {
  isValid: boolean;
  isExpired: boolean;
  hasKid: boolean;
  payload?: any;
  header?: any;
  error?: string;
};

export const validateJwtToken = (token: string): JwtValidationResult => {
  if (!token) {
    return { isValid: false, isExpired: true, hasKid: false, error: "Empty token" };
  }

  try {
    const [headerBase64, payloadBase64] = token.split('.');
    if (!headerBase64 || !payloadBase64) {
      return { isValid: false, isExpired: true, hasKid: false, error: "Malformed token" };
    }

    const header = JSON.parse(atob(headerBase64));
    const payload = JSON.parse(atob(payloadBase64));
    const exp = parseInt(payload.exp);
    const isExpired = !exp || Date.now() >= exp * 1000;
    const hasKid = !!header.kid;

    return {
      isValid: !isExpired && hasKid,
      isExpired,
      hasKid,
      payload,
      header,
    };
  } catch (err: any) {
    return {
      isValid: false,
      isExpired: true,
      hasKid: false,
      error: err?.message || "Unknown error decoding token",
    };
  }
};

export function updateParticipantIds(
  participantIds: string[] = [], 
  userId: string
): string[] {
  const newUser = `${userId}|${Date.now()}`;
  return [...participantIds, newUser];
}

export function hasUserAlreadyJoined(participantIds: string[], myUserId: string): boolean {
  let count = 0;

  for (const entry of participantIds) {
    const [userId] = entry.split("|");
    if (userId === myUserId) {
      count++;
      if (count >= 2) {
        return true; // same userId exists more than once
      }
    }
  }

  return false;
}

export const BY_ADMIN = "Admin"
  // utils/filePreview.ts
export const getFilePreview = (file: File): string | "video" | "audio" => {
    if (file.type.startsWith("video/")) {
      return "video";
    }
    if (file.type.startsWith("audio/")) {
      return podcast;
    }
    switch (file.type) {
      case "application/pdf":
        return pdfImg;
      case "application/msword":
      case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        return docsImg;
      case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      case "application/vnd.ms-excel":
        return excelPreview;
      case "application/vnd.ms-powerpoint":
      case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
        return powerpoint;
      case "application/epub+zip":
        return epub;
      default:
        if (file.type.startsWith("text/")) {
          return csvImg;
        }
        if (file.type.startsWith("image/")) {
          return URL.createObjectURL(file);
        }
        return pdfImg;
    }
  };


export const getMaxBatchSize = (type: string) => {
  const t = type.toLowerCase().trim(); // normalize

  switch (t) {
    case "image":
    case "images":
      return 10 * 5 * 1024 * 1024;

    case "audio":
    case "podcast":
      return 10 * 100 * 1024 * 1024;

    case "video":
    case "syndicated videos":
      return 10 * 100 * 1024 * 1024;

    case "pdf":
    case "questionsbank":
    case "teachingmaterials":
    case "e-books (learning materials)":
    case "e-books (question bank)":
    case "e-books (examination guide)":
    default:
      return 10 * 25 * 1024 * 1024;
  }
};

export const getIsJoinedLocalValue = () => {
    const isJoined = localStorage.getItem("isJoined") || '';
    return isJoined;
}

export const getCurrentSessionId = () => {
    const sessionId = localStorage.getItem("SessionId") || '';
    return sessionId;
}

export const getLocalParticipantId = (meetService: string) => {
    const isJoined = localStorage.getItem((meetService === JITSI) ? "jitsiLocalParticipantId" : "chimeLocalParticipantId") || '';
    return isJoined;
}

export const delay = (ms: number) => new Promise((res) => setTimeout(res, ms));
